import { createAction, props } from '@ngrx/store';

import { ErrorMessageDetails } from '@mtna/lib-ui';
import { Catalog } from '@mtna/pojo-consumer-ui';

export const getRootCatalogSuccess = createAction(
  '[Data Product/API] Get Root Catalog Success',
  props<{ catalog: Catalog }>()
);

export const getRootCatalogFailure = createAction(
  '[Data Product/API] Get Root Catalog Failure',
  props<{ error: ErrorMessageDetails }>()
);

export const getVariableCountSuccess = createAction(
  '[Data Product/API] Get Variable Count Success',
  props<{ numberOfVariables: number }>()
);

export const getVariableCountFailure = createAction(
  '[Data Product/API] Get Variable Count Failure',
  props<{ error: ErrorMessageDetails }>()
);
